// @flow
import {
  PAGE_READINESS_RESET,
  PAGE_READY,
  SET_FOOTER_VISIBILITY,
  SET_NAVBAR_VISIBILITY,
  SET_CUREFY_DOMAIN
} from './constants';
import type { Action, State } from './types';

const initialState = {
  ready: false, navbarVisibility: true, footerVisibility: true, curefyDomain: undefined
};

export default (state: State = initialState, action: Action): State => {
  switch (action.type) {
    case PAGE_READY:
      return { ...state, ready: true };
    case PAGE_READINESS_RESET:
      return { ...state, ready: false };
    case SET_NAVBAR_VISIBILITY:
      return { ...state, navbarVisibility: action?.payload };
    case SET_CUREFY_DOMAIN:
      return { ...state, curefyDomain: action?.value };
    case SET_FOOTER_VISIBILITY:
      return { ...state, footerVisibility: action?.payload };
    default:
      return state;
  }
};
